<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <uilab-mat-tree
            [dataSource]="example.nodes"
            [childrenAccessor]="childrenAccessor"
            #tree="uilabMatTree"
        >
            <uilab-mat-tree-node
                *uilabMatTreeNodeDef="let node; when: hasChild"
                uilabMatTreeNodePadding
                [uilabMatTreeNodePaddingIndent]="22"
            >
                <button
                    uilabMatIconButton
                    uilabMatTreeNodeToggle
                    aria-label="Toggle node"
                >
                    <uilab-mat-icon
                        [svgIcon]="
                            tree.isExpanded(node)
                                ? ICONS.expandFilled
                                : ICONS.nextFilled
                        "
                    ></uilab-mat-icon>
                </button>
                <span>{{ node.name }}</span>
            </uilab-mat-tree-node>

            <uilab-mat-tree-node
                *uilabMatTreeNodeDef="let node"
                uilabMatTreeNodePadding
                [uilabMatTreeNodePaddingIndent]="22"
            >
                <button uilabMatIconButton disabled></button>
                {{ node.name }}
            </uilab-mat-tree-node>
        </uilab-mat-tree>
    </avd-code-example>
}
